import * as React from "react";
import { withTranslation } from "react-i18next";
import CoreComponent from "../CoreComponent";
import PasswordModal from "../../components/PasswordModal";
import Axios, { AxiosResponse } from "axios";
import config from "../../config";
import { arrayToFormData } from "../../utils/functions";
import { toast } from "react-toastify";
import { USER_LOGIN } from "../../reducers/auth";
import { connect } from "react-redux";
import UserChangeModal from "../../components/UserChangeModal";
import { IHolder } from "../../interfaces";

interface IState {
    isOpen: boolean,
    isPasswordOpen: boolean,
    fileInput: any,
    file: any,
    holder: IHolder
}

class Preferences extends CoreComponent<any, IState> {
    state: IState = {
        isOpen: false,
        isPasswordOpen: false,
        fileInput: null,
        file: null,
        holder: null
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
        this.handlePasswordModal = this.handlePasswordModal.bind(this);
    }

    componentWillMount (){
        this.loadHolder();
    }

    async loadHolder (){
        let res = await Axios.get(`${config.api}/auth/myself`);

        if (!this.isUnmounted) {
            this.setState({
                holder: res.data.holder
            });
        }
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    handlePasswordModal() {
        this.setState({
            isPasswordOpen: !this.state.isPasswordOpen
        });
    }

    async upload() {
        let res: AxiosResponse = await Axios.post(`${config.api}/staff/change-avatar`, arrayToFormData({
            file: this.state.file
        }));

        if (res.data.status == "success") {
            toast("Аватар успешно изменён.", { type: "success" });

            let user = JSON.parse(localStorage.getItem("user"));
            user.image = res.data.url;

            localStorage.setItem('user', JSON.stringify(user));

            this.props.dispatch({
                type: USER_LOGIN,
                user,
            });
        }

    }

    render() {
        return (
            <div className="crm-menu">

                <UserChangeModal isOpen={this.state.isOpen} handleModal={this.handleModal} holder={this.state.holder}/>
                <PasswordModal isOpen={this.state.isPasswordOpen} handleModal={this.handlePasswordModal} />
                <h1 className="riz-mobi__title title-index">Настройки</h1>

                <div className="wrapper">
                    <div className="riz-mobi__btns">
                        <input type="file" style={{ display: "none" }} ref={ref => this.state.fileInput = ref} accept=".png, .jpg, .jpeg" name="logo" onChange={(e: any) => {
                            this.setState({
                                file: e.target.files.length > 0 ? e.target.files[0] : null
                            }, () => {
                                this.upload();
                            });
                        }} />
                        <a role="button" onClick={() => {
                            this.state.fileInput.click();
                        }} className="riz-mobi__btn">Изменить аватар</a>
                        <a role="button" onClick={() => {
                            this.handleModal();
                        }} className="riz-mobi__btn">Изменить данные</a>
                        <a role="button" onClick={() => {
                            this.handlePasswordModal();
                        }} className="riz-mobi__btn">Изменить пароль</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(withTranslation()(Preferences));
